import React from 'react';
import { useNavigate } from 'react-router-dom';
import VacantUnitsSection from '@/components/dashboard/Home/VacantUnitsSection';
import UIPageTitle from '@/components/shared/UIPageTitle';
import UIButton from '@/components/shared/UIButton';
import './VacantUnitsPage.scss';

const baseClass = 'VacantUnitsPage';

const BackToDashboardButton = () => {
  const navigate = useNavigate();
  return (
    <UIButton
      outline={true}
      variant="primary"
      size="medium"
      onClick={() => navigate('/dashboard')}
    >
      Back to Dashboard
    </UIButton>
  );
};

const VacantUnitsPage: React.FC = () => {
  return (
    <div className={baseClass}>
      <UIPageTitle
        title="Vacant Units"
        action={<BackToDashboardButton />}
      />
      <div className={`${baseClass}__container`}>
        <VacantUnitsSection hideViewAllButton={true} hideHeader={true} />
      </div>
    </div>
  );
};

export default VacantUnitsPage;
